@use '../../../scss/utility';
@use 'subnavigation-fly-in-item-vars';

:host {
  @include subnavigation-fly-in-item-vars.wb-subnavigation-fly-in-item-vars;

  display: block;
}

.tag {
  display: flex;
  align-items: center;
  padding: var(--subnavigation-fly-in-item-padding);
  color: var(--subnavigation-fly-in-item-text-color);
  background-color: var(--subnavigation-fly-in-item-background-color);
  text-decoration: none;
  outline: none;
  width: 100%;
  border-radius: var(--subnavigation-fly-in-item-border-radius);
  border-block-end: var(--subnavigation-fly-in-item-border-weight) solid var(--subnavigation-fly-in-item-border-color);
  position: relative;
}

button {
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
}

.notification {
  width: var(--subnavigation-fly-in-item-notification-size);
  height: var(--subnavigation-fly-in-item-notification-size);
  background-color: var(--subnavigation-fly-in-item-notification-color);

  border-radius: var(--wb-radius-full);
  position: absolute;
  inset-block-start: utility.wb-pixel-to-rem(14px);
  inset-inline-end: utility.wb-pixel-to-rem(12px);
}

:host(:hover),
:host(:focus-within) {
  @include subnavigation-fly-in-item-vars.wb-subnavigation-fly-in-item-hover-vars;
}

:host([active]) {
  @include subnavigation-fly-in-item-vars.wb-subnavigation-fly-in-item-selected-vars;
}
